import { render, staticRenderFns } from "./DetailPriceAway.vue?vue&type=template&id=3688dc03&scoped=true"
import script from "./DetailPriceAway.vue?vue&type=script&lang=js"
export * from "./DetailPriceAway.vue?vue&type=script&lang=js"
import style0 from "./DetailPriceAway.vue?vue&type=style&index=0&id=3688dc03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3688dc03",
  null
  
)

export default component.exports